import { IllustName, illustMap } from './Illust.constants';

interface IllustProps {
  name: IllustName;
}

const Illust = ({ name }: IllustProps) => {
  const OutgoingIllust = illustMap.get(name);

  return OutgoingIllust;
};

export default Illust;
